<template>
  <PageContent type="center" compClass="space-y-4">
    <div class="">
      <h1 class="font-semibold text-4xl">Tools</h1>
    </div>
    <div
      class="rounded-lg bg-gray-200 overflow-hidden shadow divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-px"
    >
      <router-link
        tag="div"
        to="/admin/tools/email-generator"
        class="rounded-tl-lg rounded-tr-lg sm:rounded-tr-none relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500"
      >
        <div>
          <span
            class="rounded-lg inline-flex p-3 bg-blue-100 text-blue-700 ring-4 ring-white"
          >
            <div class="h-6 w-6 flex items-center justify-center">
              <i class="fad fa-mail-bulk text-xl"></i>
            </div>
          </span>
        </div>
        <div class="mt-8">
          <h3 class="text-lg font-medium">
            <a href="#" class="focus:outline-none">
              <!-- Extend touch target to entire panel -->
              <span class="absolute inset-0" aria-hidden="true"></span>
              Email Generator
            </a>
          </h3>
          <p class="mt-2 text-sm text-gray-500">
            Select recent content to send out to media clients.
          </p>
        </div>
        <span
          class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
          aria-hidden="true"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
            />
          </svg>
        </span>
      </router-link>

      <router-link
        tag="div"
        to="/admin/tools/mail/list"
        class="sm:rounded-tr-lg sm:rounded-tr-none relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500"
      >
        <div>
          <span
            class="rounded-lg inline-flex p-3 bg-green-100 text-green-700 ring-4 ring-white"
          >
            <div class="h-6 w-6 flex items-center justify-center">
              <i class="fad fa-mailbox text-xl"></i>
            </div>
          </span>
        </div>
        <div class="mt-8">
          <h3 class="text-lg font-medium">
            <a href="#" class="focus:outline-none">
              <!-- Extend touch target to entire panel -->
              <span class="absolute inset-0" aria-hidden="true"></span>
              Sent emails
            </a>
          </h3>
          <p class="mt-2 text-sm text-gray-500">
            View recently sent emails and the user statistics for each.
          </p>
        </div>
        <span
          class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
          aria-hidden="true"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
            />
          </svg>
        </span>
      </router-link>

      <router-link
        tag="div"
        to="/admin/tools/announcements"
        class="relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500"
      >
        <div>
          <span
            class="rounded-lg inline-flex p-3 bg-red-50 text-red-700 ring-4 ring-white"
          >
            <div class="h-6 w-6 flex items-center justify-center">
              <i class="fad fa-bullhorn text-xl"></i>
            </div>
          </span>
        </div>
        <div class="mt-8">
          <h3 class="text-lg font-medium">
            <a href="#" class="focus:outline-none">
              <!-- Extend touch target to entire panel -->
              <span class="absolute inset-0" aria-hidden="true"></span>
              Announcements
            </a>
          </h3>
          <p class="mt-2 text-sm text-gray-500">
            Send out announcements to stringers and media clients.
          </p>
        </div>
        <span
          class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
          aria-hidden="true"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
            />
          </svg>
        </span>
      </router-link>

      <router-link
        tag="div"
        to="/admin/networks"
        class="relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500"
      >
        <div>
          <span
            class="rounded-lg inline-flex p-3 bg-yellow-50 text-yellow-700 ring-4 ring-white"
          >
            <div class="h-6 w-6 flex items-center justify-center">
              <i class="fad fa-chart-network text-xl"></i>
            </div>
          </span>
        </div>
        <div class="mt-8">
          <h3 class="text-lg font-medium">
            <a href="#" class="focus:outline-none">
              <!-- Extend touch target to entire panel -->
              <span class="absolute inset-0" aria-hidden="true"></span>
              Network Manager
            </a>
          </h3>
          <p class="mt-2 text-sm text-gray-500">
            Create and manage networks in addition to exporting network rosters.
          </p>
        </div>
        <span
          class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
          aria-hidden="true"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
            />
          </svg>
        </span>
      </router-link>

      <router-link
        tag="div"
        to="/admin/tools/coveragemap"
        class="sm:rounded-bl-lg relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500"
      >
        <div>
          <span
            class="rounded-lg inline-flex p-3 bg-purple-50 text-purple-700 ring-4 ring-white"
          >
            <div class="h-6 w-6 flex items-center justify-center">
              <i class="fas fa-globe-americas text-xl"></i>
            </div>
          </span>
        </div>
        <div class="mt-8">
          <h3 class="text-lg font-medium">
            <a href="#" class="focus:outline-none">
              <!-- Extend touch target to entire panel -->
              <span class="absolute inset-0" aria-hidden="true"></span>
              Coverage Map
            </a>
          </h3>
          <p class="mt-2 text-sm text-gray-500">
            Review national coverage of stringer users that have added their
            location to the CDN.
          </p>
        </div>
        <span
          class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
          aria-hidden="true"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
            />
          </svg>
        </span>
      </router-link>

      <router-link
        tag="div"
        to="/admin/tools/documents/faa"
        class="sm:rounded-br-lg relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500"
      >
        <div>
          <span
            class="rounded-lg inline-flex p-3 bg-gray-50 text-gray-700 ring-4 ring-white"
          >
            <div class="h-6 w-6 flex items-center justify-center">
              <i class="fad fa-drone-alt text-xl"></i>
            </div>
          </span>
        </div>
        <div class="mt-8">
          <h3 class="text-lg font-medium">
            <a href="#" class="focus:outline-none">
              <!-- Extend touch target to entire panel -->
              <span class="absolute inset-0" aria-hidden="true"></span>
              FAA Documents
            </a>
          </h3>
          <p class="mt-2 text-sm text-gray-500">
            Review and approve FAA documents submitted from users.
          </p>
        </div>
        <span
          class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
          aria-hidden="true"
        >
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"
            />
          </svg>
        </span>
      </router-link>
    </div>
    <div class="mt-4">
      <router-link
        class="px-3 py-2 bg-blue-600 text-white rounded-md"
        :to="{ name: 'AdminToolsMailErrors' }"
        >Mailing Errors</router-link
      >
    </div>
  </PageContent>
</template>

<script>
import PageContent from "@/components/PageContent";

export default {
  components: {
    PageContent
  }
};
</script>
